/**
 * Represent the last step change that has occured
 */
export enum StepChange {
    FileUpload,
    ColumnMapping,
    ValueMapping,
    ProcessedRows,
}
